module.exports = __webpack_public_path__ + "img/honortop_bg.8612b253.jpg";